import { createActions } from './createActions.ts';
import { fetchActions } from './fetchActions.ts';
import { filterActions } from './filterActions.ts';

/**
 * Combined actions object for the snippets store.
 * Actions are grouped by concern for better organization and testability:
 * - fetchActions: Data fetching and cache management
 * - createActions: Snippet creation with UI integration (flags, quick insert)
 * - filterActions: Filtering and search operations
 */
export const actions = {
	...fetchActions,
	...createActions,
	...filterActions,
};
